import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getAgentElement } from '../getAgentElement';
import { whenAgentIdle } from '../whenAgentIdle';
import { syncSituationalAwareness } from '../situationalAwareness/syncSituationalAwareness';
import { updateExtraSituationalAwarenessContext } from '../situationalAwareness/useExtraSituationalAwarenessContext';
import { renameNextThread } from './renameNextThread';

// SDK3-only: delivers a message via imperative calls on an already-mounted agent element.
// SDK2 (the embedded card agents) has no such API, so it delivers via initialQuestion instead.
export function startNewThreadWithMessage(_x, _x2) {
  return _startNewThreadWithMessage.apply(this, arguments);
}
function _startNewThreadWithMessage() {
  _startNewThreadWithMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(containerId, _ref) {
    var _agentEl$newThread;
    var message, _ref$silent, silent, _ref$threadTitle, threadTitle, _ref$coachingContext, coachingContext, onSent, agentEl;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          message = _ref.message, _ref$silent = _ref.silent, silent = _ref$silent === void 0 ? false : _ref$silent, _ref$threadTitle = _ref.threadTitle, threadTitle = _ref$threadTitle === void 0 ? '' : _ref$threadTitle, _ref$coachingContext = _ref.coachingContext, coachingContext = _ref$coachingContext === void 0 ? '' : _ref$coachingContext, onSent = _ref.onSent;
          updateExtraSituationalAwarenessContext({
            coachingContext: coachingContext || undefined
          });
          if (message) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          agentEl = getAgentElement(containerId);
          _context.next = 2;
          return agentEl === null || agentEl === void 0 || (_agentEl$newThread = agentEl.newThread) === null || _agentEl$newThread === void 0 ? void 0 : _agentEl$newThread.call(agentEl);
        case 2:
          if (coachingContext) {
            syncSituationalAwareness(agentEl);
          }

          // Registered after newThread() so it can't catch the icebreaker greeting's
          // idle/busy cycle instead of the message we're sending.
          whenAgentIdle(agentEl, function () {
            var _agentEl$sendMessage;
            renameNextThread(agentEl, threadTitle);
            agentEl === null || agentEl === void 0 || (_agentEl$sendMessage = agentEl.sendMessage) === null || _agentEl$sendMessage === void 0 || _agentEl$sendMessage.call(agentEl, message, {
              silent: silent
            });
            onSent === null || onSent === void 0 || onSent();
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _startNewThreadWithMessage.apply(this, arguments);
}